export default __webpack_public_path__ + "static/media/ART11.79f5720a.jpg";